import { Form, Link, Outlet, useActionData, useLoaderData, useNavigation } from 'react-router-dom';
import type { Campaign } from '../../../types/campaign.js';

export function CampaignDetailPage(): JSX.Element {
  const campaign = useLoaderData() as Campaign;
  const action = useActionData() as { ok?: boolean; error?: string } | undefined;
  const navigation = useNavigation();
  const saving = navigation.state === 'submitting';

  return (
    <section className="campaign-detail-page">
      <header className="page-header">
        <div><Link to="..">← Campaigns</Link><h2>{campaign.name}</h2></div>
        <span className="status-badge">{campaign.status}</span>
      </header>
      {action?.error && <div className="error">{action.error}</div>}
      {action?.ok && <div className="notice success">Saved.</div>}
      <Form method="patch" className="form-card">
        <label>Name<input name="name" defaultValue={campaign.name} required /></label>
        <label>Objective<textarea name="objective" defaultValue={campaign.objective ?? ''} /></label>
        <label>Status<select name="status" defaultValue={campaign.status}>
          {['DRAFT', 'PLANNED', 'ACTIVE', 'PAUSED', 'COMPLETED', 'CANCELLED', 'ARCHIVED'].map((status) => <option key={status}>{status}</option>)}
        </select></label>
        <label>Budget<input name="budgetAmount" type="number" defaultValue={campaign.budgetAmount ?? 0} min="0" /></label>
        <button className="btn btn-primary" type="submit" disabled={saving}>{saving ? 'Saving…' : 'Save campaign'}</button>
      </Form>
      <nav className="detail-tabs">
        <Link to="participants">Participants</Link>
        <Link to="deliverables">Deliverables</Link>
        <Link to="offers">Offers</Link>
        <Link to="analytics">Analytics</Link>
        <Link to="history">History</Link>
      </nav>
      <Outlet />
    </section>
  );
}
